import type { DispatchAllocations, MoneyAmount } from '../dispatch.api';

/** What the form holds: whole litres and whole shillings, the way a dispatcher counts them; empty fields are undefined. */
export interface AllocationFields {
  fuelLitres?: number | null;
  advance?: number | null;
  tolls?: number | null;
  weighbridge?: number | null;
}

const shillings = (value: number | null | undefined): MoneyAmount | undefined =>
  value && value > 0 ? { amountMinor: Math.round(value * 100), currency: 'KES' } : undefined;

/** The request's allocations: money in minor units, anything left empty (or zero) not sent. */
export function toAllocations(fields: AllocationFields): DispatchAllocations {
  const allocations: DispatchAllocations = {};
  if (fields.fuelLitres && fields.fuelLitres > 0) allocations.fuelAllocationLitres = Math.round(fields.fuelLitres);
  const advance = shillings(fields.advance);
  if (advance) allocations.advance = advance;
  const expectedTolls = shillings(fields.tolls);
  if (expectedTolls) allocations.expectedTolls = expectedTolls;
  const expectedWeighbridge = shillings(fields.weighbridge);
  if (expectedWeighbridge) allocations.expectedWeighbridge = expectedWeighbridge;
  return allocations;
}
